import { ApplyToJobShiftsRequest } from '../../../../Domain/Port/ApplyToJobShifts/apply-to-job-shifts.service';

export class ApplyToJobShiftsBackendRequest {
    public readonly shift_ids: number[];
    public readonly guard_rate: number;
    public readonly apply_note?: string;
    public readonly repeat_shifts: boolean;

    constructor(model: ApplyToJobShiftsRequest) {
        if (!model.shiftIDs || model.shiftIDs.length === 0) {
            throw new Error('Shift IDs are required');
        }

        if (model.guardRate === undefined) {
            throw new Error('Guard rate is required');
        }

        this.shift_ids = model.shiftIDs;
        this.guard_rate = model.guardRate;
        this.apply_note = model.notes;
        this.repeat_shifts = model.repeatShifts;
    }
}
